import { render, staticRenderFns } from "./PriceLists.vue?vue&type=template&id=562249eb&scoped=true&"
import script from "./PriceLists.vue?vue&type=script&lang=js&"
export * from "./PriceLists.vue?vue&type=script&lang=js&"
import style0 from "./PriceLists.vue?vue&type=style&index=0&id=562249eb&lang=scss&scoped=true&"
import style1 from "./PriceLists.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562249eb",
  null
  
)

export default component.exports